import React from 'react'
import { View } from 'react-native'
import { useTranslation } from 'react-i18next'

import { BtButton, BtText } from '@linqpal/components/src/ui'
import { CreateFirstProject } from '../../../../../assets/icons'

import { styles } from './styles'
import { useNavigation } from '@react-navigation/native'
import { paths } from '../../../../links'

type Props = {
  title?: string | unknown
  subtitle?: string
  btnText?: string
  params?: any
  buttonOnPress?: () => void
}

export const ProjectsEmptyContent = ({
  title,
  subtitle,
  btnText,
  params,
  buttonOnPress,
}: Props) => {
  const { t } = useTranslation('global')
  const navigation = useNavigation()
  return (
    <View style={styles.mainWrapper} testID="projects_empty_content_wrapper">
      <CreateFirstProject width={409} height={309} />
      <BtText style={styles.bottomTitle}>
        {title || t('Projects.create_first_project')}
      </BtText>
      <BtText style={styles.bottomSubtitle}>
        {subtitle || t('Projects.create_first_project_subtitle')}
      </BtText>
      {(params?.category !== 'receivable' && params?.status !== 'PAID') ||
      (params?.category !== 'payable' && params?.status !== 'PAID') ? (
        <BtButton
          testID="projects-create-button"
          style={styles.button}
          onPress={() =>
            buttonOnPress
              ? buttonOnPress()
              : navigation.navigate(paths.NewProject)
          }
        >
          {btnText || t('Projects.create_first_project')}
        </BtButton>
      ) : null}
    </View>
  )
}
